"use strict";

require("../../style/index.less");

require("../../grid/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/col/style/index.js
// module id = 62
// module chunks = 1